<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

    <sc-dialog-title>{{'create transport by profile' | translate:
        ['tmc-yard.ui.action-tablet.create-transport-by-profile.confirm-title',
        translationService.language]}}
    </sc-dialog-title>

    <sc-padding>
        <sc-flex-fitting-content>
            <sc-flex [vertical]="true" [stretchContent]="true">
                <div
                    [innerHTML]="'#undefined' | translate: 
                ['tmc-yard.ui.action-tablet.create-transport-by-profile.confirm-description', translationService.language] | trustHtml">
                </div>
                <sc-content-spacer vertical />
                <form class="form" [formGroup]="formGroup">
                    <sc-select-field formControlName="selectedEntrance" [data]="entrances" class="type-field"
                        labelDictionaryKey="tmc.transport.register.entrance.area-gate.title"></sc-select-field>
                </form>
            </sc-flex>
        </sc-flex-fitting-content>
    </sc-padding>

    <sc-separator-line></sc-separator-line>

    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
            ['tmc.transport.register.entrance.action.cancel', translationService.language]}}</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="confirm()" class="confirm-button">{{'accept' |
            translate: ['tmc.transport.register.entrance.action.accept', translationService.language]}}</button>
    </sc-actionbar>
</sc-flex>